"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emojisplosions = void 0;
const emojisplosion_1 = require("./emojisplosion");
const utils_1 = require("./utils");
/**
 * Default interval setting for fire delays.
 *
 * @returns Random number between 0 and 2100.
 */
const defaultInterval = () => 700 + Math.floor(Math.random() * 1401);
/**
 * Periodically emojisplodes across the page! 🎆
 *
 * @param settings   Settings to emojisplode.
 * @returns Handler for the ongoing emojisplosions.
 */
exports.emojisplosions = (settings = {}) => {
    const { interval = defaultInterval, scheduler = setTimeout, } = settings;
    let cancelled = false;
    const blast = () => emojisplosion_1.emojisplosion(settings);
    const blastAndSchedule = () => {
        if (cancelled) {
            return;
        }
        if (document.visibilityState === "visible") {
            blast();
        }
        scheduler(blastAndSchedule, utils_1.obtainValue(interval));
    };
    scheduler(blastAndSchedule, 0);
    return {
        blast,
        cancel() {
            cancelled = true;
        },
    };
};
